import type { CountryType } from "../@types/generic";

export const isDachProduct = (
    country: CountryType
): country is "de" | "at" | "ch" =>
    country === "de" || country === "at" || country === "ch";
